import core from "@/helpers/client";
const channelService = {
  async headChannelMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/channels`,
      params
    );
    return result;
  },
  async getChannelMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/channels`,
      params
    );
    return result;
  },
  async getChannelMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/channels/${id}`
    );
    return result;
  },
  async createChannelMasterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/channels`,
      model
    );
    return result;
  },
  async updateChannelMasterAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/channels/${id}`,
      model
    );
    return result;
  },
  async deleteChannelMasterByIdAsync(id) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_MASTER}api/v1/channels/delete/${id}`
    );
    return result;
  },
};
export default channelService;
